import { render } from "./MasterData.vue?vue&type=template&id=da445a1a&ts=true"
import script from "./MasterData.vue?vue&type=script&lang=ts"
export * from "./MasterData.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__